import { targetOrganizationsApi } from '../../redux/api/applications/target-organizations-api';

export const useGetTargetOrganizations = () => {
  const { data: targetOrganizations } =
    targetOrganizationsApi.useGetAllTargetOrganizationsQuery();

  return (targetOrganizations ?? []).map(org => ({
    value: org.id,
    label: org.name,
  }));
};
